//
import axios from 'axios'

/**
 * 
 */
const massiveUpdateSalePrices = async function ( data ) {

	//
    try {

		//
        const path     = '/wh_product/massive_margin'
            , route    = process.env.VUE_APP_API_ROUTE.concat( path )
            , response = await axios.put( route, data )
		
		//
		return response.data
    } catch( error ) {

		//
        return error.response.data
    }
}

//
export default massiveUpdateSalePrices
